import React from 'react'

const p404 = props => {
  props.history.push('/dados/')
  return <div>Página não encontrada - 404</div>
}

export default p404
